import React from 'react';
import { Table, Empty } from 'antd';
import ProductoInventarioValorizadoTable from './ProductoInventarioValorizadoTable';
import ProductoInventarioUnidadesFisicas from './ProductoInventarioUnidadesFisicas';
export default class AlmacenTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Table
                className={'logistica-table-inventario-almacen'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
                onExpand={async (expanded, record) => {
                    await this.props.onSearchInventarioProducto(record);
                }}
                expandedRowRender={(record) => {
                    if(this.props.filter.idTipoReporteInventario === 1) //VALORIZADO
                    {
                        return (
                            <div style={{ margin: '10px 0px' }}>
                                {
                                    <ProductoInventarioValorizadoTable 
                                        dataSource={record.productos} 
                                        onSearchInventarioValorizadoMovimiento={this.props.onSearchInventarioValorizadoMovimiento}
                                    />
                                }
                            </div>
                        )
                    }else{
                        return (
                            <div style={{ margin: '10px 0px' }}>
                                {
                                    <ProductoInventarioUnidadesFisicas
                                        dataSource={record.productos} 
                                        onSearchInventarioUnidadesFisicasMovimiento={this.props.onSearchInventarioUnidadesFisicasMovimiento}
                                    />
                                }
                            </div>
                        )
                    }
                  
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        title: 'Almacén',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    }
                ]}
            />
        );
    }
}